<template>
  <div v-if="izbranaStranka !== '' && seznamNarocnin.length > 0 && seznamVsehPrikljuckov.length > 0">
    <div style="padding-top: 30px"/>
    <hr class="hr-stil"/>
    <div>
      <div class="odmik-prikljucki">
        <p class="open-sans-20pt">
          {{samoMobilni ? 'Mobilni priključki' : 'Priključki'}}
        </p>
      </div>
    </div>
    <div class="sezna-prikljuckov">
      <div style="padding-bottom: 30px;">
        <el-table
          v-loading="nalaganjeUporabniskihPodatkovBox"
          :data="seznamVsehPrikljuckov"
          :expand-row-keys="expandRowKeys"
          :row-key="row => row.id_prikljucek"
          empty-text="Ni priključkov za prikaz"
          @expand-change="Izbranavrstica">
          <el-table-column
            min-width="60px"
            v-if="prikazTabele === '1'"
            label="Številka priključka">
            <template slot-scope="scope">
              {{ scope.row.id_prikljucek }}
            </template>
          </el-table-column>
          <el-table-column
            label="Tip priključka" min-width="60px">
            <template slot-scope="scope">
              {{ scope.row.tip_prikljucka_opisno }}
            </template>
          </el-table-column>
          <el-table-column
            label="Status priključka" v-if="prikazTabele === '1'">
            <template slot-scope="scope">
              {{ scope.row.statusNaziv }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="!samoMobilni"
            label="Naslov priključka" min-width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.naslov.trim().length >  1">
                {{ scope.row.naslov }}, {{ scope.row.kraj }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Mobilna številka" v-if="samoMobilni" min-width="100px">
            <template slot-scope="scope">
              {{ VrniFormatiranoTelefonsko(scope.row.podatekZaIzpisPrikljucek, '5', false, false) }}
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div v-if="osebniPodatki !== null" class="notranji-odmik">
                <div style="padding-top: 30px">
                  <p class="open-sans-16pt">
                    <b>
                      Osnovni podatki priključka
                    </b>
                  </p>
                </div>
                <div style="padding-top: 10px;">
                  <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
                    <el-form-item label="Status priključka" class="forma-visina-input" v-if="!samoMobilni">
                      <b>
                        {{ scope.row.statusNaziv }}
                      </b>
                    </el-form-item>
                  </el-form>
                  <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
                    <el-form-item label="Naslov priključka" class="forma-visina-input">
                      <b v-if="scope.row.naslov.trim().length >  1">
                        {{ scope.row.naslov }}, {{ scope.row.kraj }}
                      </b>
                    </el-form-item>
                  </el-form>
                  <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
                    <el-form-item label="ID priključka" class="forma-visina-input">
                      <b>
                        {{ scope.row.id_prikljucek }}
                      </b>
                    </el-form-item>
                  </el-form>
                  <el-form
                    v-if="scope.row.veljavnaPogodba !== null"
                    label-width="150px"
                    :label-position="formaOrientacija"
                    class="nova-vrstica-forma">
                    <el-form-item label="Podpis pogodbe" class="forma-visina-input">
                      <b>
                        {{ scope.row.veljavnaPogodba.slice(0, 10) }}
                      </b>
                    </el-form-item>
                  </el-form>
                  <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
                    <el-form-item label="Tržni paket" class="forma-visina-input">
                      <b>
                        {{ scope.row.trzni_paket }}
                      </b>
                    </el-form-item>
                  </el-form>
                </div>
                <div style="padding-top: 30px">
                  <p class="open-sans-16pt">
                    <b>
                      Naročniški podatki
                    </b>
                  </p>
                </div>
                <div style="padding-top: 10px;">
                  <el-form label-width="150px" :label-position="formaOrientacija">
                    <el-form-item label="Ime in priimek:" class="forma-visina-input">
                      <b>
                        {{ nazivUporabnika }}
                      </b>
                      <img src="/static/img/MojT2/Pregled%20storitev/Icon-awesome-lock.png"
                           class="Icon-awesome-lock">
                    </el-form-item>
                    <el-form-item label="Stalni naslov:" class="forma-visina-input">
                      <b>
                        {{ naslovUporabnika }}
                      </b>
                      <img src="/static/img/MojT2/Pregled%20storitev/Icon-awesome-lock.png"
                           class="Icon-awesome-lock">
                    </el-form-item>
                    <el-form-item label="Številka naročnika:" class="forma-visina-input">
                      <b>
                        {{ izbranaStranka }}
                      </b>
                      <img src="/static/img/MojT2/Pregled%20storitev/Icon-awesome-lock.png"
                           class="Icon-awesome-lock">
                    </el-form-item>
                  </el-form>
                  <div class="navadno-besedilo">
                    <div v-if="urejanjeKontaktniPodatki === '0'">
                      <el-form label-width="150px" :label-position="formaOrientacija">
                        <el-form-item label="Mobilna številka:" class="forma-visina-input">
                          <b>
                            {{ potrjenTelefonUporabniski.length === 11
                                ? VrniFormatiranoTelefonsko(potrjenTelefonUporabniski, '5') : potrjenTelefonUporabniski }}
                          </b>
                        </el-form-item>
                        <el-form-item label="Elektronska pošta:" class="forma-visina-input">
                          <b>
                            {{ potrjenEmailUporabniski }}
                          </b>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div class="navadno-besedilo">
                    <div v-if="urejanjeKontaktniPodatki === '1'">
                      <el-form label-width="150px" :label-position="formaOrientacija" class="urejanje">
                        <el-form-item label="Mobilna številka:" class="forma-visina-input">
                          <el-select class="lista-zacetnih-st" v-model="zacetnaStTelefonUporabniski" :placeholder="listaZacetnihSt[0]">
                            <el-option
                              v-for="st in listaZacetnihSt"
                              :value="st"
                              :label="st"
                              :key="st">
                            </el-option>
                          </el-select>
                          <el-input
                            placeholder="100100"
                            class="tel-st-vnosno-polje"
                            :maxlength="6"
                            show-word-limit
                            type="text"
                            v-model="telefonUporabniskiDrugiDel">
                          </el-input>
                        </el-form-item>
                        <el-form-item label="Elektronska pošta:" class="forma-visina-input">
                          <el-input placeholder="Vpišite elektronski naslov."
                                    v-model="emailUporabniski"
                                    class="narocniski-racun"/>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
                <div style="padding-top: 30px">
                  <p class="open-sans-16pt">
                    <b>
                      Kontaktni podatki za ta priključek
                    </b>
                  </p>
                </div>
                <div v-if="urejanjeKontaktniPodatki === '0'" style="padding-top: 10px;">
                  <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
                    <el-form-item label="Ime in priimek:" class="forma-visina-input">
                      <b>
                        {{ potrjenoImeKontakt }}
                      </b>
                    </el-form-item>
                    <el-form-item label="Mobilna številka:" class="forma-visina-input">
                      <b>
                        {{ potrjenaTelefonskaKontakt.length === 11
                            ? VrniFormatiranoTelefonsko(potrjenaTelefonskaKontakt, '5') : potrjenaTelefonskaKontakt }}
                      </b>
                    </el-form-item>
                    <el-form-item label="Elektronska pošta:" class="forma-visina-input">
                      <b>
                        {{ potrjenEmailKontakt }}
                      </b>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-if="urejanjeKontaktniPodatki === '1'">
                  <div v-loading="nalaganjeKontaktnihPodatkov" style="width: 100%; padding-top: 10px;">
                    <el-form label-width="150px" :label-position="formaOrientacija" class="urejanje-kontaktni">
                      <el-form-item label="Ime in priimek:" class="forma-visina-input">
                        <el-input placeholder="Vpišite ime."
                                  v-model="imeKontakt"
                                  class="narocniski-racun"/>
                      </el-form-item>
                      <el-form-item label="Mobilna številka:" class="forma-visina-input">
                        <el-select class="lista-zacetnih-st" v-model="telefonskaKontaktPrviDel">
                          <el-option
                            v-for="st in listaZacetnihSt"
                            :value="st"
                            :label="st"
                            :key="st">
                          </el-option>
                        </el-select>
                        <el-input
                          placeholder="100100"
                          class="tel-st-vnosno-polje"
                          :maxlength="6"
                          show-word-limit
                          type="text"
                          v-model="telefonskaKontaktDrugiDel">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="Elektronska pošta:" class="forma-visina-input">
                        <el-input placeholder="Vpišite elektornski naslov."
                                  v-model="emailKontakt"
                                  class="narocniski-racun"/>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div v-if="urejanjeKontaktniPodatki === '0'">
                  <div class="postavitev-gumba">
                    <a class="okvir-sprememba-kontaktov tekst-kontaktnih-podatkov" @click="KontaktniPodatki"
                       style="cursor: pointer">
                      UREDITE PODATKE
                    </a>
                    <a class="postavitev-gumba-storitve">
                      <el-button class="gumb-potrdi velikost-gumba-storitve" @click="odpriTabNaroceneStoritve">
                        STORITVE
                      </el-button>
                    </a>
                  </div>
                </div>
                <div v-if="urejanjeKontaktniPodatki === '1'" class="urejanje">
                  <div class="postavitev-gumba">
                    <p>
                      <el-button class="gumb-potrdi"
                                 :disabled="disableSaveButton"
                                 @click="ShraniKontaktniPodatki(); ShraniUporabniskiPodatki()" type="primary">
                        SHRANI SPREMEMBE
                      </el-button>
                      <a class="stil-gumb-preklici" @click="KontaktniPodatki"
                         type="primary">
                        PREKLIČI
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div style="clear: both"/>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center">
          <el-pagination
            :hide-on-single-page="true"
            @current-change="PrikaziStran"
            :current-page="trenutnoIzbranaStran"
            :page-size="10"
            layout="prev, pager, next"
            :total="dolzinaSeznama"
            small>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {Form, Input, CollapseItem, Collapse, TableColumn, Button, Row, Table, Option, Pagination} from 'element-ui'
import InfoKomponentaUporabniskiPodatki from './InfoKomponentaUporabniskiPodatki'
import Vue from 'vue'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import {ZacetneStevilkeUmtsEnum} from '../../../../../assets/js/Enum/ZacetneStevilkeUmtsEnum'
import {PrikljucekStatusEnum} from '../../../../../assets/js/Enum/PrikljucekStatusEnum'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
export default {
  name: 'UporabniskiPodatki',
  mixins: [PrikazVsebine, FormatirajTelefonskoStevilko],
  data () {
    return {
      clientAgent: null,
      osebniPodatki: '',
      urejanjeKontaktniPodatki: '0',
      urejanjeNarocniskihPodatkov: '0',
      potrjenEmailKontakt: '',
      emailKontakt: '',
      telefonskaKontaktPrviDel: '064',
      telefonskaKontaktDrugiDel: '',
      potrjenaTelefonskaKontakt: '',
      formaOrientacija: 'left',
      mejnaSirina: 350,
      imeKontakt: '',
      expandRowKeys: [],
      potrjenoImeKontakt: '',
      nazivUporabnika: '',
      naslovUporabnika: '',
      nalaganjeKontaktnihPodatkov: false,
      nalaganjeUporabniskihPodatkov: false,
      nalaganjeUporabniskihPodatkovBox: false,
      emailUporabniski: '',
      telefonUporabniski: '',
      potrjenEmailUporabniski: '',
      potrjenTelefonUporabniski: '',
      trenutniPodatkiNarocnika: null,
      strankaUporabniskiPodatki: '',
      izbranPrikljucek: '',
      izbranSap: '',
      seznamVsehPrikljuckov: [],
      validacija: null,
      izbranaVrstica: null,
      listaZacetnihSt: ZacetneStevilkeUmtsEnum,
      zacetnaStTelefonUporabniski: '064',
      telefonUporabniskiDrugiDel: '',
      veljavniStatusZaPrikaz: [],
      trenutnoIzbranaStran: 1,
      dolzinaSeznama: null,
      dodatenSeznam: [],
      prepovedaneStevilke: ['064064064', '38664064064', '059 00 00 00', '059 000 000', '059000000']
    }
  },
  props: {
    izbranaStranka: null,
    seznamStrank: null,
    podatkiStranke: null,
    seznamNarocnin: Array,
    upostevanjSamoNosilnePrikljucke: null,
    samoMobilni: false
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.PridobitevTrenutniNarocnik()
      }
    },
    izbranaStranka: function () {
      if (this.izbranaStranka !== null) {
        this.PridobitevTrenutniNarocnik()
        this.GetPrikljuckiDovoljenja()
      }
    },
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    seznamNarocnin: function () {
      if (this.seznamNarocnin !== null) {
        for (let i = 0; i < this.seznamNarocnin.length; i++) {
          this.strankaUporabniskiPodatki = this.seznamNarocnin[0].id_stranka
        }
        this.GetPrikljuckiDovoljenja()
      }
    }
  },
  components: {
    FormatirajTelefonskoStevilko,
    InfoKomponentaUporabniskiPodatki,
    [Input.name]: Input,
    [Form.name]: Form,
    [Option.name]: Option,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Row.name]: Row,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Table.name]: Table,
    [Pagination.name]: Pagination
  },
  mounted () {
    this.veljavniStatusZaPrikaz = [
      {
        'idStatus': PrikljucekStatusEnum.VKLOPLJEN,
        'naziv': 'Vklopljen'
      },
      {
        'idStatus': PrikljucekStatusEnum.MIROVANJE,
        'naziv': 'Mirovanje'
      },
      {
        'idStatus': PrikljucekStatusEnum.ZACASEN_IZKLOP_SU2,
        'naziv': 'Začasen izklop'
      },
      {
        'idStatus': PrikljucekStatusEnum.PRIKLOP_V_TEKU,
        'naziv': 'Priklop v teku'
      }
    ]
    this.validacija = new Validacija()
    this.clientAgent = new ClientAgent()
    this.GetPrikljuckiDovoljenja()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  computed: {
    disableSaveButton () {
      return (this.telefonUporabniskiDrugiDel.length !== 0 && this.telefonUporabniskiDrugiDel.length !== 6) ||
             (this.telefonskaKontaktDrugiDel.length !== 0 && this.telefonskaKontaktDrugiDel.length !== 6)
    }
  },
  methods: {
    PrikaziStran (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.dodatenSeznam[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamVsehPrikljuckov = this.dodatenSeznam[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamVsehPrikljuckov = []
      }
    },
    odpriTabNaroceneStoritve () {
      this.$emit('odpriTabStoritve')
    },
    Izbranavrstica (row) {
      if (row !== null) {
        this.izbranaVrstica = row
        const id = row.id_prikljucek
        const lastId = this.expandRowKeys[0]
        this.expandRowKeys = id === lastId ? [] : [id]
        for (let i = 0; i < this.seznamVsehPrikljuckov.length; i++) {
          if (typeof this.seznamVsehPrikljuckov !== 'undefined' && this.seznamVsehPrikljuckov[i].id_prikljucek === id) {
            this.izbranPrikljucek = this.seznamVsehPrikljuckov[i].id_prikljucek
            this.emailKontakt = this.seznamVsehPrikljuckov[i].email_kontakt
            this.potrjenEmailKontakt = this.seznamVsehPrikljuckov[i].email_kontakt
            this.potrjenaTelefonskaKontakt = this.seznamVsehPrikljuckov[i].telefon_kontakt
            let potrjenaTelefonskaKontakt = this.seznamVsehPrikljuckov[i].telefon_kontakt.replace(/\D/g, '')
            this.telefonskaKontaktPrviDel = this.GetZacetna(potrjenaTelefonskaKontakt)
            this.telefonskaKontaktDrugiDel = this.GetDrugiDelTelefonske(potrjenaTelefonskaKontakt)
            this.potrjenoImeKontakt = this.seznamVsehPrikljuckov[i].ime_priimek_kontakt
            this.imeKontakt = this.seznamVsehPrikljuckov[i].ime_priimek_kontakt
          }
        }
        this.PridobitevTrenutniNarocnik()
      }
    },
    KontaktniPodatki () {
      if (this.urejanjeKontaktniPodatki === '1') {
        this.urejanjeKontaktniPodatki = '0'
      } else {
        this.urejanjeKontaktniPodatki = '1'
      }
    },
    NarocniskiPodatki () {
      if (this.urejanjeNarocniskihPodatkov === '1') {
        this.urejanjeNarocniskihPodatkov = '0'
      } else {
        this.urejanjeNarocniskihPodatkov = '1'
      }
    },
    GetCelaTelefonska (stevilkaPrviDel, stevilkaDrugiDel) {
      if (stevilkaDrugiDel !== '' && stevilkaDrugiDel.length === 6) {
        return '386' + (stevilkaPrviDel.slice(1, 3)).concat((stevilkaDrugiDel))
      }
      return ''
    },
    GetZacetna (telefonskaStevilka) {
      let zacetnaStevilka = ''
      if (telefonskaStevilka.length === 11) {
        zacetnaStevilka = 0 + telefonskaStevilka.slice(3, 5)
      } else if (telefonskaStevilka.length === 9) {
        zacetnaStevilka = telefonskaStevilka.slice(0, 3)
      }
      if (this.listaZacetnihSt.includes(zacetnaStevilka)) {
        return zacetnaStevilka
      } else {
        return this.listaZacetnihSt[0]
      }
    },
    GetDrugiDelTelefonske (telefonskaStevilka) {
      if (telefonskaStevilka.length === 11) {
        return telefonskaStevilka.slice(5, 12)
      } else if (telefonskaStevilka.length === 9) {
        return telefonskaStevilka.slice(3, 9)
      }
      return ''
    },
    ShraniKontaktniPodatki () {
      let preverjanjeMaila = false
      let telefonskaStevilka = this.GetCelaTelefonska(this.telefonskaKontaktPrviDel, this.telefonskaKontaktDrugiDel)
      if (this.prepovedaneStevilke.includes(telefonskaStevilka)) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Dodajanje te številke med kontaktne podatke ni mogoč.'
        this.ShowWarningMessage(paramObvestilo)
        return
      }
      if (this.potrjenEmailKontakt !== this.emailKontakt) {
        if (this.validacija.EmailValid(this.emailKontakt)) {
          preverjanjeMaila = true
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Neveljavna oblika emaila.'
          this.ShowWarningMessage(paramObvestilo)
        }
      }
      if (preverjanjeMaila && this.potrjenEmailKontakt !== this.emailKontakt || telefonskaStevilka !==
        this.potrjenaTelefonskaKontakt || this.potrjenoImeKontakt !== this.imeKontakt) {
        if (this.izbranPrikljucek !== '') {
          this.potrjenEmailKontakt = this.emailKontakt
          this.potrjenaTelefonskaKontakt = telefonskaStevilka
          this.potrjenoImeKontakt = this.imeKontakt
          let param = []
          param.push('idPrikljucek=' + this.izbranPrikljucek)
          param.push('kontaktEmail=' + this.potrjenEmailKontakt)
          param.push('kontaktTelefon=' + telefonskaStevilka)
          param.push('kontaktnaOseba=' + this.potrjenoImeKontakt)
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/spremembaPodatkov?',
            param,
            null,
            'SetShranikontaktniPodatki',
            'ErrShranikontaktniPodatki')
        }
      }
    },
    SetShranikontaktniPodatki () {
      this.izbranPrikljucek = ''
      this.urejanjeKontaktniPodatki = '0'
      this.Izbranavrstica(this.izbranaVrstica)
      this.PridobitevTrenutniNarocnik()
      this.GetPrikljuckiDovoljenja()
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljeni kontaktni podatki.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrShranikontaktniPodatki (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    ShraniUporabniskiPodatki () {
      let telefonskaStevilka = this.GetCelaTelefonska(this.zacetnaStTelefonUporabniski, this.telefonUporabniskiDrugiDel)
      if (this.prepovedaneStevilke.includes(telefonskaStevilka)) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Dodajanje te številke med naročniške podatke ni mogoč.'
        this.ShowWarningMessage(paramObvestilo)
        return
      }
      if (
        this.potrjenTelefonUporabniski !== telefonskaStevilka ||
        this.potrjenEmailUporabniski !== this.emailUporabniski ||
        this.potrjenTelefonUporabniski !== this.telefonUporabniski) {
        this.nalaganjeUporabniskihPodatkov = true
        if (this.izbranaStranka !== '') {
          this.potrjenEmailUporabniski = this.emailUporabniski
          this.potrjenTelefonUporabniski = this.telefonUporabniski
          let param = []
          param.push('idStranka=' + this.izbranaStranka)
          param.push('email=' + this.potrjenEmailUporabniski)
          param.push('gsm=' + telefonskaStevilka)
          this.clientAgent.postWsRequest(
            this,
            '/stranka/spremembaKontakta?',
            param,
            null,
            'SetShraniUporabniskiPodatki',
            'ErrShraniUporabniskiPodatki')
        }
      }
    },
    SetShraniUporabniskiPodatki () {
      this.urejanjeKontaktniPodatki = '0'
      this.PridobitevTrenutniNarocnik()
      this.nalaganjeUporabniskihPodatkov = false
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljeni naročniški podatki.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrShraniUporabniskiPodatki (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PridobitevTrenutniNarocnik () {
      this.nalaganjeUporabniskihPodatkovBox = true
      if (this.izbranaStranka !== null && this.izbranaStranka !== '') {
        let param = ['permissionId=STRANKE']
        param.push('filter[id_stranka]=' + this.izbranaStranka)
        this.clientAgent.postWsRequest(
          this,
          '/permissions/havePermission',
          param,
          null,
          'SetPridobitevTrenutniNarocnik',
          'ErrPridobitevTrenutniNarocnik')
      }
    },
    SetPridobitevTrenutniNarocnik (podatki) {
      if (typeof podatki.permission.additionalData !== 'undefined') {
        for (let i = 0; i < podatki.permission.additionalData.length; i++) {
          this.trenutniPodatkiNarocnika = podatki.permission.additionalData[i]
          this.nazivUporabnika = this.trenutniPodatkiNarocnika.naziv
          this.naslovUporabnika = this.trenutniPodatkiNarocnika.naslov + ', ' + this.trenutniPodatkiNarocnika.kraj
          this.emailUporabniski = this.trenutniPodatkiNarocnika.email
          this.telefonUporabniski = this.trenutniPodatkiNarocnika.gsm
          let potrjenaTelefonskaUporabniski = this.telefonUporabniski.replace(/\D/g, '')
          this.zacetnaStTelefonUporabniski = this.GetZacetna(potrjenaTelefonskaUporabniski)
          this.telefonUporabniskiDrugiDel = this.GetDrugiDelTelefonske(potrjenaTelefonskaUporabniski)
          this.potrjenEmailUporabniski = this.trenutniPodatkiNarocnika.email
          this.potrjenTelefonUporabniski = this.trenutniPodatkiNarocnika.gsm
          break
        }
      }
      this.nalaganjeUporabniskihPodatkovBox = false
    },
    ErrPridobitevTrenutniNarocnik (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeUporabniskihPodatkovBox = false
    },
    GetPrikljuckiDovoljenja () {
      let param = ['permissions[]=PRIKLJUCKI', 'permissions[]=PREPAID_PRIKLJUCKI']
      this.clientAgent.postWsRequest(
        this,
        'permissions/all',
        param,
        null,
        'SetPrikljuckiDovoljenja',
        'ErrPrikljuckiDovoljenja')
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      this.skupniSeznamPrikljuckov = []
      let listIds = this.veljavniStatusZaPrikaz.map(({idStatus}) => (idStatus))
      this.seznamPrikljuckov = podatki.results.PRIKLJUCKI.additionalData.filter(
        x => listIds.includes(x.idStatus) &&
         (this.samoMobilni ? (x.tip_prikljucka === 'UMTS') : (x.tip_prikljucka === 'OTT' || x.tip_prikljucka === 'FIX'))
      )
      if (this.seznamPrikljuckov.length > 0) {
        for (let i = 0; i < this.seznamPrikljuckov.length; i++) {
          if (this.seznamPrikljuckov[i].id_stranka === this.izbranaStranka) {
            if (this.seznamPrikljuckov[i].umts_stevilka !== '') {
              Vue.set(this.seznamPrikljuckov[i], 'podatekZaIzpisPrikljucek', this.seznamPrikljuckov[i].umts_stevilka)
            }
            this.izbranSap = this.seznamPrikljuckov[i].id_stranka_sap
            if (this.seznamPrikljuckov[i].izklopljeneVseStoritve === '0' ||
                this.seznamPrikljuckov[i].tip_prikljucka !== 'OTT') {
              this.seznamVsehPrikljuckov.push(this.seznamPrikljuckov[i])
            }
          }
        }
        this.$emit('seznamPrikljuckov', this.seznamVsehPrikljuckov)
      }
      if (!this.samoMobilni) {
        this.seznamPrikljuckovOtt = podatki.results.PREPAID_PRIKLJUCKI.additionalData
        if (this.seznamPrikljuckovOtt.length > 0) {
          for (let i = 0; i < this.seznamPrikljuckovOtt.length; i++) {
            if (this.seznamPrikljuckovOtt[i].id_stranka === this.izbranaStranka &&
              this.seznamPrikljuckovOtt[i].izklopljeneVseStoritve === '0') {
              Vue.set(this.seznamPrikljuckovOtt[i], 'podatekZaIzpisPrikljucek', this.seznamPrikljuckovOtt[i].nazivPrikljuckaIzbirnik)
              this.seznamVsehPrikljuckov.push(this.seznamPrikljuckovOtt[i])
            }
          }
        }
      }
      this.seznamVsehPrikljuckov.forEach((prikljucek) => {
        Vue.set(prikljucek, 'statusNaziv',
          this.veljavniStatusZaPrikaz.find(x => prikljucek.idStatus === x.idStatus).naziv)
        Vue.set(
          prikljucek,
          'veljavnaPogodba',
          prikljucek.veljavnaPogodba !== null ? FormatDatuma.methods.PoenotenIzgledDatuma(prikljucek.veljavnaPogodba) : null
        )
      })
      if (this.seznamVsehPrikljuckov.length > 0) {
        this.izbranPrikljucek = this.seznamVsehPrikljuckov[0].id_prikljucek
      }
      this.dolzinaSeznama = this.seznamVsehPrikljuckov.length
      this.PridobitevTrenutniNarocnik()

      let tmpArray = []
      const chunk = 10
      for (let i = 0; i < this.dolzinaSeznama; i += chunk) {
        tmpArray.push(this.seznamVsehPrikljuckov.slice(i, i + chunk))
      }
      this.dodatenSeznam = tmpArray
      this.PrikaziStran(1)
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/PregledStoritev/UporabniskiPodatki.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Pregledstoritev/UporabniskiPodatki.vue